module.exports = __webpack_public_path__ + "img/water-outer-corner.e8ef702d.png";